import { MaintenanceWindowRebootOptionsController } from '../controller/MaintenanceWindowRebootOptionsController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { MaintenanceWindowRebootOptionsData } from '../types';

export class MaintenanceWindowRebootOptionsWebComponent extends BaseWebComponentElement {
  public controller: MaintenanceWindowRebootOptionsController | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MaintenanceWindowRebootOptionsController,
    });
  }

  get disabled(): boolean {
    const attributeValue = this.getAttribute('disabled');
    return attributeValue !== null;
  }

  set disabled(value: boolean) {
    if (value) {
      this.setAttribute('disabled', 'true');
    } else {
      this.removeAttribute('disabled');
    }
    this.controller?.view.setDisabledInnerComponents(value);
  }

  get viewData(): MaintenanceWindowRebootOptionsData | any {
    const attributeValue = this.getAttribute('data-view-data');

    return attributeValue ? JSON.parse(attributeValue) : undefined;
  }

  set viewData(value: MaintenanceWindowRebootOptionsData) {
    this.setAttribute('data-view-data', JSON.stringify(value));
    this.controller?.render();
  }
}
